
import useInfiniteScroll from "../../../../hooks/useInfiniteScroll";

import React, { FC, memo, useState, useMemo, useEffect, useRef } from "../../../../lib/teact/teact";
import Avatar from "../../../common/Avatar";
import Button from "../../../ui/Button";
import ConfirmDialog from "../../../ui/ConfirmDialog";
import DropdownMenu from "../../../ui/DropdownMenu";
import InfiniteScroll from "../../../ui/InfiniteScroll";
import ListItem from "../../../ui/ListItem";
import MenuItem from "../../../ui/MenuItem";
import { LotScreenSettings } from "../../config/uiconfig";
import DonViTienDialog from "../../contact/donViTienDialog";
import { Dexiedb } from "../../db/Dexiedb";
import { globalDexieDb } from "../../db/DexiedbLib";
import { deleteMessageLocal } from "../../db/report/localBackend";
import { changeViewType, fetchBasicTotalReport, fetchContactReport3Mien, fetchContactReportAllInOne, removeItem, updateMienDaiCuoc } from "../../redux/basicReport";
import { updateEditedMessageId, updateWorkDate } from "../../redux/global";
import Parser from "../../restapi/parser";
import store from "../../store";
import LotLoading from "../../ui/loading";
import LotSelect from "../../ui/lotSelect";
import Snackbar from "../../ui/snackbar";
import { getDateStringVN } from "../../utils/DateTimeUtils";
import { tienFormat } from "../../utils/NumberUtils";
import { GetTinhId, GetUserFullInfo, isCuPhapMb, isCuPhapMn, isLocalMode, Remove2C3C4C } from "../../utils/common";
import { GetGuestContactId, isGuest } from "../../utils/guest";
import { highlightVietnameseHTML } from "../../utils/searchUtils";
import { getSMSMauBinhTan } from "../templete/reportBinhTan";
import { getSMSMau5 } from "../templete/reportMau5";
import { getSMSMauMienTay } from "../templete/reportMienTay";
import { getSMSMau5MienTay } from "../templete/reportMienTayMau5";
import { getSMSMau5_1MienTay } from "../templete/reportMienTayMau5_1";
import { GetLaiLoByPhanTramThau, GetTextTienHoi, TinhTienHoi, TinhTienLaiSauHoiText, getSMSMau1 } from "../templete/reportTemplete";
import DialogTinTrungNhau from "./DialogTinTrungNhau";
import ChooseSmsDialog from "./chooseSmsDialog";
import DetailsReport from "./detailsReport";
import DialogSearchMessage from "./dialogSearchMessage";
import { writeBaMienTotalReportHtmlFile, writeDetailsReportHtmlFile, writeTotalReportHtmlFile } from "./reportHtmlFileWriter";
import TotalReportByMessage from "./totalReportByMessage";
import './totalReportByMessage.scss'
type OwnProp = {

    onChangeScreen: (screen: LotScreenSettings) => void;
}
type TotalDisplayTemplete = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | undefined;
const SMS_TEMPLATE_COUNT = 7;

const TotalReportByContact: FC<OwnProp> = ({

    onChangeScreen,
}) => {
    const dateInputRef = useRef<HTMLInputElement>(null);
    const curContact: any = store.getState().contact.currentContact
    const globalStore = store.getState().global
    const [state, setState] = useState({
        totalReport: store.getState().basicReport.totalReport,
        idListTinTrungNhau: [] as number[],
        isLoading: false,
        proccessing: false,
        confirmDeleteOpen: false,
        confirmDeleteIndex: -1,
        apiMessage: "",
        snackbarOpen: false,
        mienDaiCuocId: store.getState().basicReport.mienDaiCuocId + "",
        ngay: store.getState().global.workDate,
        deletedItem: -1,
        deletedId: "",
        chooseDialogOpen: false,
        sapXepTin: 2,
        showDialogTinTrungNhau: false,
        dataTrungNhau: [] as any[],
        showSearchDialog: false,
        searchQuery: "",
        showQuyDoiDonVitien: false,
        activeMessageIndex: -1,
    })
    const stateRef = useRef(state)
    stateRef.current = state
    useEffect(() => {
        const promise = new Promise(async (resolve, reject) => {
            const tinhId = GetTinhId()
            const found = GetUserFullInfo()
            resolve(found)
        })
        promise.then((found: any) => {
            setState(prev => ({ ...prev, sapXepTin: found.sapXepTin }))
        })

    }, [])
    useEffect(() => {
        setState(prev => ({ ...prev, isLoading: true }))
        const payload: any = {
            contactId: isGuest() ? GetGuestContactId() : curContact!.contactId,
            messageId: 0,
            ngay: globalStore.workDate,
            mienDaiCuocId: state.mienDaiCuocId
        }
        if (state.mienDaiCuocId != '0') {
            store.dispatch(fetchContactReportAllInOne(payload))
        } else {
            store.dispatch(fetchContactReport3Mien(payload))
        }

    }, [state.ngay, state.mienDaiCuocId, state.deletedId])
    useEffect(() => {
        const unsubscribe = store.subscribe(() => {
            const basicReport = store.getState().basicReport
            if (!basicReport.isLoading) {
                setState(prev => ({
                    ...prev, isLoading: false,
                    totalReport: basicReport.totalReport
                }))
            }
        })
        if (isCuPhapMb()) {
            setState(prev => ({ ...prev, mienDaiCuocId: "1" }))
            store.dispatch(updateMienDaiCuoc({ mienDaiCuocId: "1" }))
        }
        return unsubscribe;
    }, [])

    const oldOffsetId = undefined
    const listIds = useMemo(() => {
        if (!state.totalReport) {
            return undefined;
        }
        let result: any[] = []
        const showTinTrung = state.idListTinTrungNhau.length > 0
        state.totalReport.map((item: any, index: number) => {
            if (showTinTrung && state.idListTinTrungNhau.includes(item.messageId))
                result.push(index)
            else if (!showTinTrung)
                result.push(index)
        }
        )
        return result
    }, [state.totalReport, state.idListTinTrungNhau]);
    const [viewportIds, getMore] = useInfiniteScroll(undefined, listIds, false, 15, oldOffsetId);
    function handleShowMessageDetails(viewType: string, index: number) {
        const row = state.totalReport[index]
        const payload = { viewType: viewType, index }
        setState(prev => ({ ...prev, activeMessageIndex: index }))
        store.dispatch(changeViewType(payload))
    }
    function handleOpenDeleteItemDialog(index: number) {
        if (index > 0)
            setState(prev => ({ ...prev, confirmDeleteOpen: true, confirmDeleteIndex: index }))
    }
    function handleDeleteItem() {
        const msg: any = state.totalReport[state.confirmDeleteIndex]
        if (isLocalMode()) {
            setState(prev => ({ ...prev, confirmDeleteOpen: false }))
            deleteMessageLocal(msg.messageId).then(res => {
                store.dispatch(removeItem({ index: state.confirmDeleteIndex }))
                setState(prev => ({ ...prev, deletedId: JSON.stringify(new Date()) }))
            })

        } else {
            if (msg) {
                Parser.deleteMessage(msg.messageId).then((result: any) => {
                    setState(prev => ({ ...prev, confirmDeleteOpen: false }))
                    if (result.errorCode == 0) {
                        // const tmp = [...state.totalReport]
                        // tmp.splice(state.confirmDeleteIndex, 1)
                        store.dispatch(removeItem({ index: state.confirmDeleteIndex }))
                        setState(prev => ({ ...prev, deletedId: JSON.stringify(new Date()) }))

                    } else {
                        showSnackbar(result.responseText)
                    }
                })
            } else {
                showSnackbar(`Lỗi không tìm thấy message index:${state.confirmDeleteIndex}`)
            }
        }

    }
    function showSnackbar(message: string) {
        setState(prev => ({ ...prev, apiMessage: message, snackbarOpen: true }))
    }
    function getSmsTemplateByIndex(templateIndex: number): string {
        if (!state.totalReport || state.totalReport.length == 0) {
            return "";
        }
        let smsFirst = "" // mẫu đầu tiên
        let total = 0
        let totalHoi = 0
        let mau1 = ""
        let mauBinhTan = ""
        let mauMienTay = ""
        let mauMau5 = ""

        let mauMau5_1MienTay = ""

        let mauMau5MienTay = ""
        let phanTramThau = 0
        if (state.mienDaiCuocId != '0') {
            const message0: any = state.totalReport[0]
            smsFirst = getSmsCongNo(message0)
            //copyTextToClipboard(smsGoc)
            //showSnackbar("Đã copy tin nhắn công nợ.")
            mau1 = getSMSMau1([state.totalReport[0]]);
            mauBinhTan = getSMSMauBinhTan([state.totalReport[0]]);
            mauMienTay = getSMSMauMienTay([state.totalReport[0]]);
            mauMau5 = getSMSMau5([state.totalReport[0]]);
            mauMau5MienTay = getSMSMau5MienTay([state.totalReport[0]]);
            phanTramThau = message0.phanTramThau
            mauMau5_1MienTay = getSMSMau5_1MienTay([state.totalReport[0]]);
        } else {
            mau1 = getSMSMau1(state.totalReport);
            mauBinhTan = getSMSMauBinhTan(state.totalReport);
            mauMienTay = getSMSMauMienTay(state.totalReport);
            mauMau5 = getSMSMau5(state.totalReport);
            mauMau5MienTay = getSMSMau5MienTay(state.totalReport);
            mauMau5_1MienTay = getSMSMau5_1MienTay(state.totalReport);
            state.totalReport.map((message0: any) => {
                const smsGoc = getSmsCongNo(message0)
                phanTramThau = message0.phanTramThau
                total += message0.laiLo
                totalHoi += TinhTienHoi(message0)
                if (smsFirst == "")
                    smsFirst += smsGoc + "\n"
                else
                    smsFirst += "**********\n" + smsGoc + "\n"
            })
            const totalSauPt = total / 100 * (100 - phanTramThau)
            const totalHoiSauPt = totalHoi
            smsFirst += "\nTổng cộng " + (total > 0 ? "Thu:" : (total < 0 ? "Bù: " : "")) + GetLaiLoByPhanTramThau(total, phanTramThau) + GetTextTienHoi(totalSauPt, totalHoiSauPt)
            // copyTextToClipboard(sms)
            // showSnackbar("Đã copy tin nhắn công nợ ba miền.")
        }
        const templates = [
            smsFirst,
            mau1,
            mauBinhTan,
            mauMienTay,
            mauMau5,
            mauMau5MienTay,
            mauMau5_1MienTay,
        ];
        return templates[templateIndex] || "";
    }
    function handleCopyCongNo() {
        setState(prev => ({ ...prev, chooseDialogOpen: true }))
    }
    function handleReloadItem(messageIndex: number) {
        const mien = store.getState().basicReport.mienDaiCuocId;
        const message: any = store.getState().basicReport.totalReport[messageIndex]
        let messageId = 0
        if (mien == 0) {
            console.log(`load total by mien ${mien}`)
        } else {
            console.log(`load total by mien ${mien}`)
            if (messageIndex > 0)
                messageId = message.messageId;
        }
        const payload: any = {
            contactId: isGuest() ? GetGuestContactId() : curContact!.contactId,
            messageId: messageId,
            ngay: globalStore.workDate,
            mienDaiCuocId: message.mienDaiCuocId
        }
        store.dispatch(fetchBasicTotalReport(payload))
    }
    /*Mẫu 1*/
    function getSmsCongNo(message0: any) {
        let smsGoc = "Ngày: " + getDateStringVN(message0.date) + " " + message0.contactName
            + "\r\n" + message0.mienText
        let smsThuong = ""
        message0.children && message0.children.length > 0 ? message0.children.map((group: any) => {
            const xac = tienFormat(group.xac)
            const quaCo = tienFormat(group.quaCo)
            smsGoc += `\n${group.groupName}:${xac}=${quaCo}n`
            group.children.map((loaiCuoc: any) => {
                const xac = tienFormat(loaiCuoc.xac)
                const quaCo = tienFormat(loaiCuoc.quaCo)
                const lcId = Remove2C3C4C(loaiCuoc.loaiCuocId);
                smsGoc += `\n\t- ${lcId}:${xac}=${quaCo}n`
                //x
                if (loaiCuoc.trung != 0) {
                    const trung = loaiCuoc.trung
                    const thuong = tienFormat(loaiCuoc.thuong)
                    smsThuong += (smsThuong == "" ? "" : "\n") + `Trúng: ${loaiCuoc.loaiCuocId}: ${trung}=${thuong}n`
                }

            })
        }) : undefined
        smsGoc += "\n" +
            smsThuong + "\n" +
            "----------\n" +
            message0.mienText + " " + TinhTienLaiSauHoiText(message0)
        return smsGoc
    }
    function handleDialogOnCopy() {
        showSnackbar("Đã copy tin nhắn công nợ")
    }
    function getCurrentTotalDisplayTemplete(): TotalDisplayTemplete {
        const smsIndex = Number(localStorage["smsIndex"]);
        if (Number.isInteger(smsIndex) && smsIndex >= 0 && smsIndex <= 9) {
            return smsIndex as TotalDisplayTemplete;
        }
        return undefined;
    }
    async function handleDownloadTotalReportHtml() {
        if (state.mienDaiCuocId == '0') {
            const downloadedFile = await writeBaMienTotalReportHtmlFile(state.totalReport, {
                totalDisplayTemplete: getCurrentTotalDisplayTemplete(),
            });
            showSnackbar("Đã tải file total ba miền: " + downloadedFile);
            return;
        }
        const itemByActiveIndex: any =
            state.activeMessageIndex >= 0 ? state.totalReport?.[state.activeMessageIndex] : undefined;
        const currentDetailsItem: any = state.totalReport?.find((item: any) => item.viewType == "details");
        const fallbackTotalItem: any = state.totalReport?.find((item: any) => item.messageId == 0)
            || (state.totalReport && state.totalReport.length > 0 ? state.totalReport[0] : undefined);
        const exportingItem = itemByActiveIndex || currentDetailsItem || fallbackTotalItem;
        if (!exportingItem) {
            showSnackbar("Không có dữ liệu total report để tải");
            return;
        }
        if (exportingItem.viewType == "details") {
            const downloadedFile = await writeDetailsReportHtmlFile(exportingItem);
            showSnackbar("Đã tải file details: " + downloadedFile);
        } else {
            const downloadedFile = await writeTotalReportHtmlFile(exportingItem, {
                totalDisplayTemplete: getCurrentTotalDisplayTemplete(),
            });
            showSnackbar("Đã tải file total: " + downloadedFile);
        }
    }
    function searchTinTrungNhau(): any[] {
        const messages: any = state.totalReport;
        const mapText: Map<string, number> = new Map()
        const mapData: Map<string, number> = new Map()
        const arrTrung: any[] = []
        for (let msg of messages) {
            if (msg.messageId == 0)
                continue;
            const keyText = msg.textChecksum;
            const keyData = msg.dataChecksum;
            let itemText = mapText.get(keyText);
            let itemData = mapData.get(keyData);
            if (!itemText) {
                mapText.set(keyText, 1)
            } else {
                mapText.set(keyText, itemText + 1)
            }
            if (!itemData) {
                mapData.set(keyData, 1)
            } else {
                mapData.set(keyData, itemData + 1)

            }
        }
        /*  for (let [key, value] of mapData) {
             if (value > 1) {
                 const arr = messages.filter((msg: any) => msg.dataChecksum == key)
                 arrTrung.push(arr)
             }
         } */
        for (let [key, value] of mapData) {
            if (value > 1) {
                const arr = messages.filter((msg: any) => msg.dataChecksum == key)
                arrTrung.push(...arr)
            }
        }

        if (arrTrung.length > 0) {
            setState(prev => ({ ...prev, showDialogTinTrungNhau: true, dataTrungNhau: arrTrung }))
        } else {
            showSnackbar("Không có tin trùng nhau")
        }
        return arrTrung
    }
    function searchTinNhan(): any[] {
        const messages: any = state.totalReport;
        const idListFilteredMessage: number[] = []
        const arrTrung: any[] = []
        for (let msg of messages) {
            if (msg.type==1){
                arrTrung.push(msg)
                idListFilteredMessage.push(msg.messageId)
            }
        }
       
       
        if (arrTrung.length > 0) {
            if (arrTrung.length > 0) {

                setState(prev => ({
                    ...prev, idListTinTrungNhau: idListFilteredMessage,
                    dataTrungNhau: arrTrung,
                     
                }))
            }
        } else {
            showSnackbar("Không có tin nhận")
        }
        return arrTrung
    }
    function searchTinChuyen(): any[] {
        const messages: any = state.totalReport;
        const idListFilteredMessage: number[] = []
        const arrTrung: any[] = []
        for (let msg of messages) {
            if (msg.type==2){
                arrTrung.push(msg)
                idListFilteredMessage.push(msg.messageId)
            }
        }
       
       
        if (arrTrung.length > 0) {
            if (arrTrung.length > 0) {

                setState(prev => ({
                    ...prev, idListTinTrungNhau: idListFilteredMessage,
                    dataTrungNhau: arrTrung,
                     
                }))
            }
        } else {
            showSnackbar("Không có tin chuyển")
        }
        return arrTrung
    }
    function searchByContent(searchQuery: string) {
        const arrTrung: any[] = []
        const messages: any = stateRef.current.totalReport;
        const idListFilteredMessage: number[] = []
        for (let msg of messages) {
            const hilight = highlightVietnameseHTML(msg.body, searchQuery);
            if (hilight != "") {
                arrTrung.push(msg)
                idListFilteredMessage.push(msg.messageId)
            }

        }
        if (arrTrung.length > 0) {

            setState(prev => ({
                ...prev, idListTinTrungNhau: idListFilteredMessage,
                dataTrungNhau: arrTrung,
                searchQuery: searchQuery,
            }))
        } else {
            setState(prev => ({ ...prev, searchQuery: searchQuery }))
        }
        return arrTrung
    }
    function showAllMessages() {
        setState(prev => ({ ...prev, idListTinTrungNhau: [], searchQuery: "" }))
    }
    function handleOnConfirmShowTinTrungNhau(idListTinTrungNhau: number[]) {
        setState(prev => ({ ...prev, idListTinTrungNhau: idListTinTrungNhau }))

    }
    function showQuyDoiDonVitien() {
        setState(prev => ({ ...prev, showQuyDoiDonVitien: true }))
    }
    function getItemHilight(item: any): string | undefined {
        if (!state.searchQuery || state.searchQuery.length < 2 || !item || !item.body) {
            return undefined;
        }
        const hilight = highlightVietnameseHTML(item.body, state.searchQuery);
        return hilight || undefined;
    }
    return (
        <div className="form-main">
            <div className="form-header">
                <div className="form-header left-panel">
                    <Button
                        round
                        size="default"
                        color="translucent"
                        onClick={() => isGuest() ? undefined : onChangeScreen(LotScreenSettings.CONTACT_LIST_SCREEN)}
                    //className={buildClassName(styles.headerButton, styles.firstButton)}
                    //ariaLabel={lang(isFullscreen ? 'AccExitFullscreen' : 'AccSwitchToFullscreen')}
                    >
                        <i
                            className='icon icon-arrow-left'
                            aria-hidden
                        />
                    </Button>
                    <Avatar
                        //photo={notPersonalPhoto}
                        noPersonalPhoto
                        //peer={user}
                        text={curContact ? curContact.name : ""}
                        size="small"
                        className="personal-photo"
                    />
                    <div>{curContact ? curContact.name : ""}</div>
                </div>
                <div className="form-header right-panel">
                    <Button
                        onClick={() => {
                            store.dispatch(updateEditedMessageId({ editingMessage: undefined }))
                            onChangeScreen(LotScreenSettings.NHAP_TIN_NHAN_SCREEN)
                        }
                        }
                        round
                        size="default"
                        color="translucent" >
                        <i className="fa-solid fa-plus"></i>
                    </Button>
                    <DropdownMenu positionX="right">
                        <MenuItem icon="search"
                            onClick={() => {
                                setState(prev => ({ ...prev, showSearchDialog: true }))
                            }}
                        >
                            Tìm kiếm
                        </MenuItem>
                        <MenuItem icon="double-badge"
                            onClick={searchTinTrungNhau}>
                            Tin trùng nhau
                        </MenuItem>
                        <MenuItem icon="my-notes"
                            onClick={searchTinNhan}>
                            Tin nhận
                        </MenuItem>
                        <MenuItem icon="transcribe"
                            onClick={searchTinChuyen}>y
                            Tin Chuyển
                        </MenuItem>
                        <MenuItem icon="readchats"
                            onClick={showAllMessages}>
                            Hiển thị tất cả các tin
                        </MenuItem>
                        <MenuItem icon="readchats"
                            onClick={showQuyDoiDonVitien}>
                            Quy đổi đơn vị tiền
                        </MenuItem>
                    </DropdownMenu>
                </div>


            </div>
            <div className=" form-content">
                <div className="common-container-row">
                    <div className="common-container-row left-panel">
                        <LotSelect value={state.mienDaiCuocId} id="b"
                            onChange={(e) => {
                                setState(prev => ({ ...prev, mienDaiCuocId: e.target.value }))
                                store.dispatch(updateMienDaiCuoc({ mienDaiCuocId: e.target.value }))
                            }
                            }>
                            {
                                isCuPhapMn() ? <>
                                    <option value="3" selected={state.mienDaiCuocId == '3'}>Miền Nam</option>
                                    <option value="2" selected={state.mienDaiCuocId == '2'}>Miền Trung</option>
                                    <option value="1" selected={state.mienDaiCuocId == '1'}>Miền Bắc</option>
                                    <option value="0" selected={state.mienDaiCuocId == '0'}>Ba miền</option></>
                                    : <option value="1" selected={state.mienDaiCuocId == '1'}>Miền Bắc</option>
                            }

                        </LotSelect>
                    </div>
                    <div className="common-container-row right-panel">
                        {state.mienDaiCuocId == '0' && <Button round
                            size="smaller"
                            color="translucent"
                            onClick={handleDownloadTotalReportHtml}
                        >
                            <i className="fa-solid fa-file-arrow-down"></i>
                        </Button>}
                        <input id="basic-report-date" type="date" className="date-input" value={state.ngay}
                            pattern="\d{2}/\d{2}/\d{4}" placeholder="dd/mm/yyyy"
                            ref={dateInputRef}
                            onChange={(e) => {
                                setState(prev => ({ ...prev, ngay: e.target.value }))
                                store.dispatch(updateWorkDate({ workDate: e.target.value }))
                            }
                            }
                        />
                        <Button round
                            size="smaller"
                            color="translucent"
                            onClick={handleCopyCongNo}
                        >
                            <i className="fa-regular fa-copy"></i>
                        </Button>
                    </div>
                </div>

                {/* <ProgressSpinner/> */}
                {/* <DateSuggest searchDate="2023-08-08" onSelect={()=>{}}/> */}
                {/* <CalendarModal isOpen={true} onClose={()=>{}} onSubmit={()=>{}}
                    withTimePicker
                    secondButtonLabel="Chọn"
                    submitButtonLabel="submit"
                /> */}
                <InfiniteScroll
                    // style="height:calc(100% - var(--header-height))"

                    items={viewportIds} onLoadMore={getMore} className="chat-list custom-scroll">
                    {
                        state.isLoading ? <LotLoading key="loading" text='Đang tải dữ liệu chi tiết' /> :
                            (viewportIds ?
                                viewportIds.map((it: any, index: number) => {
                                    const item: any = state.totalReport[it]
                                    let id = "msg-id-" + it
                                    if (item.messageId != 0)
                                        id = item.messageId
                                    return (
                                        <div key={"msg-" + it} id={id} style="width:100%;">
                                            <ListItem className="Listitem-button-nopadding"
                                                onClick={(e) => {
                                                    //console.log('ListItem clicked')
                                                }}
                                                contextActions={[
                                                    {
                                                        handler: () => {
                                                            //handleDanhBaClick(id, domId)
                                                            onChangeScreen(LotScreenSettings.CONTACT_LIST_SCREEN)
                                                        },
                                                        title: 'Trở về mà hình trước',
                                                        icon: 'readchats',
                                                    },
                                                ]}
                                            >
                                                {item.viewType == "group" && <TotalReportByMessage
                                                    hilight={getItemHilight(item)}
                                                    key={"msg-2-" + it}
                                                    data={item}
                                                    messageIndex={it}
                                                    onChangeViewType={handleShowMessageDetails}
                                                    onRemoveItem={handleOpenDeleteItemDialog}
                                                    onReloadItem={handleReloadItem}
                                                    onChangeScreen={onChangeScreen}
                                                    soTin={state.sapXepTin == 2 ? state.totalReport.length - it : it}
                                                    totalDisplayTemplete={getCurrentTotalDisplayTemplete()}

                                                />}
                                                {item.viewType == "details" && <DetailsReport
                                                    key={"msg-3-" + it}
                                                    message={item} index={it}
                                                    onChangeViewType={handleShowMessageDetails}
                                                    onRemoveItem={handleOpenDeleteItemDialog}
                                                    onChangeScreen={onChangeScreen}
                                                    soTin={state.sapXepTin == 2 ? state.totalReport.length - it : it}
                                                />}
                                            </ListItem>
                                        </div>
                                    )
                                })
                                : <div key={"nodata-000"}>Không có dữ liệu</div>)
                    }
                    {
                        !state.isLoading && state.mienDaiCuocId == '0' ? (
                            <div key={"total3mien-"} style="width:100%;">
                                <ListItem className="Listitem-button-nopadding">
                                    {
                                        (() => {
                                            let total = 0;
                                            let totalText = ""
                                            let phanTramThau = 0
                                            state.totalReport.map((msg: any) => {
                                                total += msg.laiLoSauHoi
                                                totalText += totalText == "" ? msg.mienText : (" + " + msg.mienText)
                                                phanTramThau = msg.phanTramThau
                                            })
                                            let laiLo = total;
                                            return (
                                                <div style="width:100%">
                                                    <div>{totalText} </div>
                                                    <div className=
                                                        {"basic-lailo " + (total < 0 ? "lo" : "lai")}>
                                                        {total > 0 ? "Lãi: " : (total < 0 ? "Lỗ: " : "")}
                                                        {tienFormat(laiLo, 1)}

                                                    </div>
                                                </div>)
                                        })()
                                    }
                                </ListItem>
                            </div>) : undefined
                    }

                </InfiniteScroll>
            </div>
            <ConfirmDialog
                text="Xoá tin nhắn hiện tại"
                title="Xác nhận xoá"
                confirmLabel="Xoá"
                isOpen={state.confirmDeleteOpen}
                onClose={() => { setState(prev => ({ ...prev, confirmDeleteOpen: false })) }}
                confirmHandler={handleDeleteItem}
                confirmIsDestructive={true}
            />
            <Snackbar isOpen={state.snackbarOpen}
                message={state.apiMessage}
                onClose={() => { setState(prev => ({ ...prev, snackbarOpen: false })) }}
                triggerTime={JSON.stringify(new Date())}
            />
            <ChooseSmsDialog isOpen={state.chooseDialogOpen}
                smsCount={SMS_TEMPLATE_COUNT}
                getSmsByIndex={getSmsTemplateByIndex}
                onClose={() => { setState(prev => ({ ...prev, chooseDialogOpen: false })) }}
                onCopy={handleDialogOnCopy}
            ></ChooseSmsDialog>
            <DialogTinTrungNhau isOpen={state.showDialogTinTrungNhau}
                onClose={() => { setState(prev => ({ ...prev, showDialogTinTrungNhau: false })) }
                }
                dataTrung={state.dataTrungNhau}
                onConfirm={handleOnConfirmShowTinTrungNhau}
            />
            <DialogSearchMessage isOpen={state.showSearchDialog}
                onSearchConfirm={(searchQuery: string) => { searchByContent(searchQuery) }}
                onClose={() => { setState(prev => ({ ...prev, showSearchDialog: false })) }}
            />
            <DonViTienDialog isOpen={state.showQuyDoiDonVitien}
                onClose={() => { setState(prev => ({ ...prev, showQuyDoiDonVitien: false })) }}
                contactId={isGuest() ? GetGuestContactId() : curContact!.contactId}
            />
        </div>
    )
}

export default memo(TotalReportByContact)